// Shares a public link via the native share sheet when available (phones),
// otherwise copies it to the clipboard. Returns how the link was handled so
// callers can decide whether to show a "link copied" confirmation.
export async function shareProfileLink({ path, title }) {
  const url = path.startsWith('http') ? path : `${window.location.origin}${path}`;
  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return 'shared';
    } catch (err) {
      if (err && err.name === 'AbortError') return 'cancelled';
      // Share sheet failed for another reason — fall through to clipboard.
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return 'copied';
  } catch {
    window.prompt('Copy this link:', url);
    return 'prompted';
  }
}
